import { CounterOrderDirection } from "@/app/types/generated/graphql";

import { CounteredOrdersView, useCounteredOrders } from "../components/countered-orders";

export const MyCounterOffers = () => {
  const logic = useCounteredOrders(CounterOrderDirection.Outgoing);

  return <CounteredOrdersView {...logic} />;
};
